import { GridLoader } from 'react-spinners'

export const Loader = () => {
    return <GridLoader
        color="#2e3192"
        size={15}
        speedMultiplier={2}
    />
}